import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  template: '',
})
export abstract class BaseAreaAccordionComponent implements OnInit, OnDestroy {
  @Input() componentId: string;

  public showItemList = false;

  protected destroyed$ = new Subject<void>();

  constructor(protected accordionService: AccordionService) {}

  ngOnInit(): void {
    if (this.componentId) {
      // Subscribe to changes in the currently open component
      this.accordionService
        .getCurrentOpenComponent()
        .pipe(takeUntil(this.destroyed$))
        .subscribe((openComponentId) => {
          this.showItemList = openComponentId === this.componentId;
        });

      // Set monitors component as initially open
      if (this.componentId === 'monitors') {
        this.accordionService.openComponent('monitors');
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  showItems(): void {
    if (this.componentId) {
      if (this.showItemList) {
        // If this component is open, close it
        this.accordionService.closeComponent(this.componentId);
      } else {
        // If this component is closed, open it (which will close others)
        this.accordionService.openComponent(this.componentId);
      }
    } else {
      // Fallback to original behavior if no componentId is provided
      this.showItemList = !this.showItemList;
    }
  }
}
